module.exports = __webpack_public_path__ + "static/media/cullycode.dd02eee1.png";